<template>
  <div class="fluid container">
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">オプション</h3>
      </div>
      <div class="panel-body" style="display: flex">
        <div class="checkbox" style="padding-right: 10px">
          <label><input type="checkbox" v-model="editable">移動可能</label>
        </div>
        <div class="checkbox" style="padding-right: 10px">
          <label><input type="checkbox" v-model="tooltipShow">ツールチップ</label>
        </div>
        <div class="checkbox" style="padding-right: 10px">
          <button type="button" class="btn" @click="orderLists">並び替え</button>
        </div>
        <div class="checkbox" style="padding-right: 10px">
          <input type="text" v-model="keyword" placeholder="Search">
        </div>
        <div class="tooltipText" v-bind:style="tooltipPosition">{{tooltipText}}</div>
        {{tooltipPosition}}
      </div>
    </div>

    <div style="display: flex">
      <div class="panel" style="flex: 1">
        <div class="panel-heading">
          <h3 class="panel-title">先探し 20% 上にバー<span class="badge">{{filteredLists1.length}}</span></h3>
        </div>
        <div class="panel-body">
          <!-- <draggable class="list&#45;group" tag="ul" v&#45;model="lists1" v&#45;bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false"> -->
          <draggable class="list-group" tag="ul" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <li @mousemove="onListMouseMove" @mouseenter="onListMouseEnter(element)" @mouseleave="onListMouseLeave" class="list-group-item" v-for="element in filteredLists1" :key="'1' + element.id">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.name}}
                <span class="badge">{{element.id}}</span>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>

      <div class="panel" style="flex: 1">
        <div class="panel-heading">
          <h3 class="panel-title">探し中<span class="badge">{{filteredLists2.length}}</span></h3>
        </div>
        <div class="panel-body">
          <!-- <draggable class="list&#45;group" tag="ul" v&#45;model="lists2" v&#45;bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false"> -->
          <draggable class="list-group" tag="ul" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <li @mousemove="onListMouseMove" @mouseenter="onListMouseEnter(element)" @mouseleave="onListMouseLeave" class="list-group-item" v-for="element in filteredLists2" :key="'2' + element.id">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.name}}
                <span class="badge">{{element.id}}</span>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>

      <div class="panel" style="flex: 1">
        <div class="panel-heading">
          <h3 class="panel-title">研修待ち<span class="badge">{{filteredLists3.length}}</span></h3>
        </div>
        <div class="panel-body">
          <draggable class="list-group" tag="ul" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <li @mousemove="onListMouseMove" @mouseenter="onListMouseEnter(element)" @mouseleave="onListMouseLeave" class="list-group-item" v-for="element in filteredLists3" :key="'3' + element.id">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.name}}
                <span class="badge">{{element.id}}</span>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>
      
      <div class="panel" style="flex: 1">
        <div class="panel-heading">
          <h3 class="panel-title">資料郵送待ち<span class="badge">{{filteredLists4.length}}</span></h3>
        </div>
        <div class="panel-body">
          <draggable class="list-group" tag="ul" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <li @mousemove="onListMouseMove" @mouseenter="onListMouseEnter(element)" @mouseleave="onListMouseLeave" class="list-group-item" v-for="element in filteredLists4" :key="'4' + element.id">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.name}}
                <span class="badge">{{element.id}}</span>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>

      <div class="panel" style="flex: 1">
        <div class="panel-heading">
          <h3 class="panel-title">紹介待ち<span class="badge">{{filteredLists5.length}}</span></h3>
        </div>
        <div class="panel-body">
          <draggable class="list-group" tag="ul" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <li @mousemove="onListMouseMove" @mouseenter="onListMouseEnter(element)" @mouseleave="onListMouseLeave" class="list-group-item" v-for="element in filteredLists5" :key="'5' + element.id">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.name}}
                <span class="badge">{{element.id}}</span>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>

      <div class="panel" style="flex: 1">
        <div class="panel-heading">
          <h3 class="panel-title">完了<span class="badge">{{filteredLists6.length}}</span></h3>
        </div>
        <div class="panel-body">
          <draggable class="list-group" tag="ul" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <li @mousemove="onListMouseMove" @mouseenter="onListMouseEnter(element)" @mouseleave="onListMouseLeave" class="list-group-item" v-for="element in filteredLists6" :key="'6' + element.id">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.name}}
                <span class="badge">{{element.id}}</span>
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>
    </div>

    <!-- <div style="display: flex"> -->
    <!--   <div class="list&#45;group" style="flex: 1"> -->
    <!--     <pre>{{lists1String}}</pre> -->
    <!--   </div> -->
    <!--   <div class="list&#45;group" style="flex: 1"> -->
    <!--     <pre>{{lists2String}}</pre> -->
    <!--   </div> -->
    <!--   <div class="list&#45;group" style="flex: 1"> -->
    <!--     <pre>{{lists3String}}</pre> -->
    <!--   </div> -->
    <!--   <div class="list&#45;group" style="flex: 1"> -->
    <!--     <pre>{{lists4String}}</pre> -->
    <!--   </div> -->
    <!--   <div class="list&#45;group" style="flex: 1"> -->
    <!--     <pre>{{lists5String}}</pre> -->
    <!--   </div> -->
    <!--   <div class="list&#45;group" style="flex: 1"> -->
    <!--     <pre>{{lists6String}}</pre> -->
    <!--   </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'statesindex',

  data () {
    return {
      editable: true,
      isDragging: false,
      delayedDragging: false,
      keyword: '',
      tooltipShow: true,
      tooltipText: '',
      tooltipPosition: {
        left: 0,
        top: 0,
        visibility: 'hidden'
      }
    }
  },

  methods: {
    onListMouseMove (e) {
      // console.log(e.pageX, e.pageY)
      if (this.tooltipShow) {
        this.tooltipPosition.left = e.pageX + 'px'
        this.tooltipPosition.top = e.pageY + 'px'
        this.tooltipPosition.visibility = 'visible'
      } else {
        return
      }
    },

    onListMouseEnter (list) {
      // console.log(list)
      this.tooltipText = `name ${list.name}
id ${list.id}`
    },

    onListMouseLeave () {
      this.tooltipPosition.visibility = 'hidden'
    },

    orderLists () {
      this.lists1 = this.lists1.sort((one, two) => {
        return one.id - two.id
      })
      this.lists2 = this.lists2.sort((one, two) => {
        return one.id - two.id
      })
      this.lists3 = this.lists3.sort((one, two) => {
        return one.id - two.id
      })
      this.lists4 = this.lists4.sort((one, two) => {
        return one.id - two.id
      })
      this.lists5 = this.lists5.sort((one, two) => {
        return one.id - two.id
      })
      this.lists6 = this.lists6.sort((one, two) => {
        return one.id - two.id
      })
    },

    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    }
  },

  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    },

    // lists () {
    //   return this.$store.getters.lists
    // },

    lists: {
      get () {
        return this.$store.state.list.lists
      },
      set (value) {
        this.$store.commit('lists', {
          state: 6
        })
      }
    },

    lists1String () {
      return JSON.stringify(this.lists1, null, 2)
    },

    lists2String () {
      return JSON.stringify(this.lists2, null, 2)
    },

    lists3String () {
      return JSON.stringify(this.lists3, null, 2)
    },

    lists4String () {
      return JSON.stringify(this.lists4, null, 2)
    },

    lists5String () {
      return JSON.stringify(this.lists5, null, 2)
    },

    lists6String () {
      return JSON.stringify(this.lists6, null, 2)
    },

    lists1 () {
      return this.lists.filter(list => {
        return list.state === 1
      })
    },

    lists2 () {
      return this.lists.filter(list => {
        return list.state === 2
      })
    },

    lists3 () {
      return this.lists.filter(list => {
        return list.state === 3
      })
    },

    lists4 () {
      return this.lists.filter(list => {
        return list.state === 4
      })
    },

    lists5 () {
      return this.lists.filter(list => {
        return list.state === 5
      })
    },

    lists6 () {
      return this.lists.filter(list => {
        return list.state === 6
      })
    },

    filteredLists1 () {
      var lists = []
      for (var i in this.lists1) {
        var list = this.lists1[i]
        if (list.name.indexOf(this.keyword) !== -1) {
          lists.push(list)
        }
      }
      return lists
    },

    filteredLists2 () {
      var lists = []
      for (var i in this.lists2) {
        var list = this.lists2[i]
        if (list.name.indexOf(this.keyword) !== -1) {
          lists.push(list)
        }
      }
      return lists
    },

    filteredLists3 () {
      var lists = []
      for (var i in this.lists3) {
        var list = this.lists3[i]
        if (list.name.indexOf(this.keyword) !== -1) {
          lists.push(list)
        }
      }
      return lists
    },

    filteredLists4 () {
      var lists = []
      for (var i in this.lists4) {
        var list = this.lists4[i]
        if (list.name.indexOf(this.keyword) !== -1) {
          lists.push(list)
        }
      }
      return lists
    },

    filteredLists5 () {
      var lists = []
      for (var i in this.lists5) {
        var list = this.lists5[i]
        if (list.name.indexOf(this.keyword) !== -1) {
          lists.push(list)
        }
      }
      return lists
    },

    filteredLists6 () {
      var lists = []
      for (var i in this.lists6) {
        var list = this.lists6[i]
        if (list.name.indexOf(this.keyword) !== -1) {
          lists.push(list)
        }
      }
      return lists
    }
  },

  watch: {
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
  border-color: #ddd;
}

.panel-heading {
  color: #333;
  background-color: #f5f5f5;
  padding: 10px 15px;
  border-bottom: 1px solid #ddd;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}

.panel-body {
  padding: 15px;
}

.radio, .checkbox {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}

.btn {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border-radius: 4px;
}

.list-group-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  margin: 0;
  padding: 0;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.badge {
  float: right;
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #777;
  border-radius: 10px;
}

.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: 'Glyphicons Halflings';
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #333;
  word-break: break-all;
  word-wrap: break-word;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.tooltipText {
  z-index: 9999;
  position: absolute;
  width: 500px;
  height: 200px;
  background: white;
  border: solid 1px #ccc;
  white-space: pre;
  transform: translate(-50%, calc(-100% - 15px));
}
</style>



// WEBPACK FOOTER //
// StatesIndex.vue?855b8e94